/**
 * Created by jacmai on 3/14/2017.
 */
define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "textcomplete",
  "overlay",
  "./template/apiRequestItemTemplate.html",
], function (Marionette, _, Messenger, TextComplete, Overlay, ApiRequestItemTemplate) {
  var ApiRequestView = {};

  ApiRequestView.apiRequestView = Marionette.ItemView.extend({
    template: ApiRequestItemTemplate,
    events: {
      "change #httpMethodSelect": function () {
        var optionSelected = this.$el.find("#httpMethodSelect option:selected").val();
        this.model.set("httpMethod", optionSelected);
        if (optionSelected === "POST" || optionSelected === "PUT") {
          this.$el.find("#apiRequestBodyControls").show();
        } else {
          this.$el.find("#apiRequestBodyControls").hide();
        }
      },
      "change #apiSelect": function () {
        var optionSelected = parseInt(this.$el.find("#apiSelect option:selected").val(), 10);
        this.model.set("apiId", optionSelected);
        this.setPathPlaceholder(this.model.apis.get(optionSelected));
      },
    },
    clearErrors: function () {
      this.$el.find("div.error-message").remove();
    },
    apiError: function (errorMessage) {
      this.$el
        .find("#requestApiError")
        .html('<div class="error-message">' + errorMessage + "</div>")
        .hide()
        .fadeIn();
    },
    pathError: function (errorMessage) {
      this.$el
        .find("#requestPathError")
        .html('<div class="error-message">' + errorMessage + "</div>")
        .hide()
        .fadeIn();
    },
    requestBodyError: function (errorMessage) {
      this.$el
        .find("#requestBodyError")
        .html('<div class="error-message">' + errorMessage + "</div>")
        .hide()
        .fadeIn();
    },
    getRequestPath: function () {
      return this.$el.find("#apiRequestPath").val();
    },
    getRequestBody: function () {
      return this.$el.find("#apiRequestBody").val();
    },
    onRender: function () {
      var apiId = this.model.get("apiId");
      if (apiId > 0) {
        this.setPathPlaceholder(this.model.apis.get(apiId));
      } else {
        //no apis exist in the KB, so show a message
        this.apiError(this.model.validateAttribute("apiId", apiId));
      }

      var variables = Messenger.reqres.request("action:all:variables").pluck("name");
      var bracedVariables = [];
      variables.forEach(function (variable) {
        bracedVariables.push("{" + variable + "}");
      });
      this.$el.i18n();
      var strategies = [
        {
          match: /(\{)([\w ]+)$/, //matches text inside braces (optional closing brace)
          search: function (term, callback) {
            term = term.toLowerCase();
            var matches = variables.filter(function (variable) {
              return variable.toLowerCase().indexOf(term) === 0;
            });
            callback(matches);
          },
          replace: function (word) {
            return "{" + word + "}";
          },
        },
      ];

      var pathOverlayStrategies = [
        {
          match: bracedVariables,
          css: {
            "background-color": "rgba(191, 42, 42, 0.3)",
            "border-radius": "3px",
            "padding-bottom": "2px",
          },
        },
        {
          match: /\{[\w ]*}?/g,
          css: {
            "background-color": "rgba(141, 141, 141, 0.3);",
            "border-radius": "3px",
            "padding-bottom": "2px",
          },
        },
      ];

      var bodyOverlayStrategies = [
        {
          match: bracedVariables,
          css: {
            "background-color": "rgba(191, 42, 42, 0.3)",
            "border-radius": "3px",
            "padding-bottom": "2px",
          },
        },
        {
          match: /\{[\w ]+}?/g,
          css: {
            "background-color": "rgba(141, 141, 141, 0.3);",
            "border-radius": "3px",
            "padding-bottom": "2px",
          },
        },
      ];

      this.$el
        .find("#apiRequestPath")
        .textcomplete(strategies, { zIndex: "1110" })
        .overlay(pathOverlayStrategies);

      this.$el
        .find("#apiRequestBody")
        .textcomplete(strategies, { zIndex: "1110" })
        .overlay(bodyOverlayStrategies);
    },
    setPathPlaceholder: function (apiModel) {
      this.$el.find("#apiRequestPath").attr("placeholder", apiModel.get("endpointUrl"));
    },
  });

  return ApiRequestView;
});
